import React from 'react'
import styled from 'styled-components'
import { Input, InputProps } from 'sutra/components/Input/Input'

import { cardBorder, errorRed } from 'assets/styles/variables'

type Props = InputProps & { isError?: boolean }
export const YogiInput = React.forwardRef<HTMLInputElement, Props>(
  ({ placeholder, value, onChange, style, isError, ...props }, ref) => {
    return (
      <CustomInput
        ref={ref}
        placeholder={placeholder}
        value={value}
        style={{
          ...style,
        }}
        onChange={onChange}
        $isError={!!isError}
        {...props}
      />
    )
  },
)
YogiInput.displayName = 'YogiInput'

const CustomInput = styled(Input)<{ $isError: boolean }>`
  :placeholder-shown {
    font-style: italic;
  }
  border-radius: 10px;
  border: 2px solid ${({ $isError }) => ($isError ? errorRed : cardBorder)} !important;
  box-shadow: 0 0 5px 0 #00000026;
`
